import {
    GET_PRESUPUESTO, GENERATE_PRESUPUESTO, UPDATE_PRESUPUESTO_DETALLE, COPIAR_PRESUPUESTO, CAMBIAR_BLOQUEO_PRESUPUESTO
} from '../constants/action_types';

const initialState = { presupuesto: {}, isLoading: false, reload: true, copied: false };

export default function (state = initialState, action) {

    switch (action.type) {

        case GET_PRESUPUESTO:

            return { ...state, isLoading: true, reload: false, copied: false };

        case GET_PRESUPUESTO + "_SUCCESS":

            return { ...state, presupuesto: action.payload.data, isLoading: false, reload: false, copied: false };

        case GENERATE_PRESUPUESTO:

            return { ...state, isLoading: true };

        case GENERATE_PRESUPUESTO + "_SUCCESS":

            return { ...state, isLoading: false, reload: true, copied: false };
        
        case GENERATE_PRESUPUESTO + "_FAILURE":

            return { ...state, isLoading: false, reload: false, copied: false };

        case COPIAR_PRESUPUESTO + "_SUCCESS":

            return { ...state, isLoading: false, reload: false, copied: true };

        case UPDATE_PRESUPUESTO_DETALLE + "_SUCCESS":

            return { ...state, presupuesto: state.presupuesto, isLoading: false, reload: true, copied: false };

        case CAMBIAR_BLOQUEO_PRESUPUESTO + "_SUCCESS":

            return { ...state, presupuesto: { ...state.presupuesto, cerrado: !state.presupuesto.cerrado }, copied: false };

        default:

            return state;
    }

}